import styled from "@emotion/styled"

export const MetricContainer = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  height: "100%",
  gap: "8px",
})

export const MetricText = styled.span({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1,
  minWidth: 0, // Important for text truncation in flexbox
})

export const IconWrapper = styled.div({
  flexShrink: 0, // Prevent icon from shrinking
  display: "flex",
  alignItems: "center",
})


